import   axios                      from 'axios';
import { API_URLS                 } from '../urls';
import { BackendResponse          ,
         handleError              } from '../../dataTypes/backendServicesManagment/types';
import { SalesCampaign            ,
         initializedSalesCampaign ,
		 SalesAction              ,
		 initializedSalesAction   } from '../../dataTypes/salesCampaignManagment/types';

import { createUpload } from '../fileManagment/uploadWithStore';

export interface BackendResponse_SalesCampaign extends BackendResponse<SalesCampaign[]> {}

export interface BackendResponse_SalesAction extends BackendResponse<SalesAction[]> {}


const parseDate = (dateObject: any): Date => {
  return dateObject ? new Date(dateObject.date) : new Date();
};

// Fonction pour récupérer les campagnes de ventes
export const getSalesCampaigns = async (adminId?: number): Promise<BackendResponse_SalesCampaign> => {
  const url = API_URLS.getSalesCampaigns;

  try {
    const response = await axios.get(url, { params: adminId ? { adminId } : {} });

    console.log (url, response)


    if (response.status === 200) {
      const salesCampaigns: SalesCampaign[] = response.data.map((campaign: any) => {
        const defaultCampaign = initializedSalesCampaign();

        const salesActions: SalesAction[] = campaign.salesActions.map((action: any) => {
          const defaultAction = initializedSalesAction();
          return {
            ...defaultAction,
            id                   : action.id                   ?? defaultAction.id,
            creationDate         : parseDate(action.creationDate),
            name                 : action.name                 ?? defaultAction.name                 ,
            active               : action.active               ?? defaultAction.active               ,
			mediaId              : action.mediaId              ?? defaultAction.mediaId              ,
            productId            : action.productId            ?? defaultAction.productId            ,
            productVariant       : action.productVariant       ?? defaultAction.productVariant       ,
            productImage         : action.productImage         ?? defaultAction.productImage         ,
            duration             : action.duration             ?? defaultAction.duration             ,
            timecode             : action.timecode             ?? defaultAction.timecode             ,
            adPosition           : action.adPosition           ?? defaultAction.adPosition           ,
            adWidth              : action.adWidth              ?? defaultAction.adWidth              ,
            onlyQRcode           : action.onlyQRcode           ?? defaultAction.onlyQRcode           ,
            comment1             : action.comment1             ?? defaultAction.comment1             ,
            comment2             : action.comment2             ?? defaultAction.comment2             ,
            shapeColor1          : action.shapeColor1          ?? defaultAction.shapeColor1          ,
            shapeColor2          : action.shapeColor2          ?? defaultAction.shapeColor2          ,
            backgroundColor1     : action.backgroundColor1     ?? defaultAction.backgroundColor1     ,
            backgroundColor2     : action.backgroundColor2     ?? defaultAction.backgroundColor2     ,
            withImage            : action.withImage            ?? defaultAction.withImage            ,
            alternateImageId     : action.alternateImageId     ?? defaultAction.alternateImageId     ,
            alternateImageUrl    : action.alternateImageUrl    ?? defaultAction.alternateImageUrl    ,
            alternateImageFile   : action.alternateImageFile   ?? defaultAction.alternateImageFile   ,
            redirectionId        : action.redirectionId        ?? defaultAction.redirectionId        ,
            redirectionUuid      : action.redirectionUuid      ?? defaultAction.redirectionUuid      ,
			redirectionTargetUrl : action.redirectionTargetUrl ?? defaultAction.redirectionTargetUrl ,
            redirectionImageId   : action.redirectionImageId   ?? defaultAction.redirectionImageId   ,
			redirectionImageUrl  : action.redirectionImageUrl  ?? defaultAction.redirectionImageUrl  ,
			redirectionImageFile : action.redirectionImageFile ?? defaultAction.redirectionImageFile ,
            resultImageFile      : action.resultImageFile      ?? defaultAction.resultImageFile      ,
          };
        });

        return {
          ...defaultCampaign,
          id                  : campaign.id              ?? defaultCampaign.id,
          name                : campaign.name            ?? defaultCampaign.name,
          active              : campaign.active          ?? defaultCampaign.active,
          activeScheduled     : campaign.activeScheduled ?? defaultCampaign.activeScheduled,
          comment             : campaign.comment         ?? defaultCampaign.comment,
          creationDate        : parseDate(campaign.creationDate),
          creationIpAddress   : campaign.creationIpAddress ?? defaultCampaign.creationIpAddress,
          lastUpdateDate      : campaign.lastUpdateDate      ?  new Date(campaign.lastUpdateDate) : null,
          lastTranscodingDate : campaign.lastTranscodingDate ?  new Date(campaign.lastTranscodingDate) : null,
          state               : campaign.state,
          beginningDate       : campaign.beginningDate ? parseDate(campaign.beginningDate) : defaultCampaign.beginningDate,
          endingDate          : campaign.endingDate    ? parseDate(campaign.endingDate)    : defaultCampaign.endingDate,
          salesActions        : salesActions,
        };
      });

      return {
        code: 1,
        comment: 'The retrieval of sales campaigns is complete.',
        payload: salesCampaigns,
      };
    } else {
      return handleError<SalesCampaign[]>(response.status, 'Non-200 response from API');
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      return handleError<SalesCampaign[]>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<SalesCampaign[]>(-102, 'Unknown error');
  }
};

export const createSalesCampaign = async ( name            : string                              ,
                                           active          : boolean                             ,
                                           activeScheduled : boolean                             ,
                                           beginningDate   : Date | null                         ,
                                           endingDate      : Date | null                         ,
                                           salesActions    : SalesAction[]                       ,
                                           setProgress?    : ((progress: number) => void) | null ,
                                           adminId?        : number                              ) => {
  const url = `${API_URLS.createSalesCampaign}`;


  console.log ('>>>>>>>>>>>>>>>>>>>>>>>>>>>> createSalesCampaign :' , name, active, beginningDate, endingDate, salesActions )

  const formData = new FormData();

  // Ajout des champs principaux de la campagne
                     formData.append ('name'           , name                       );
                     formData.append ('active'         , active.toString()          );
                     formData.append ('activeScheduled', activeScheduled.toString() );
  if (beginningDate) formData.append ('beginningDate'  , beginningDate.toISOString());
  if (endingDate)    formData.append ('endingDate'     , endingDate.toISOString()   );
  if (adminId)       formData.append ('adminId'        , adminId.toString()        );

  // Ajout des actions de vente associées à la campagne
  formData.append('salesActions.length', salesActions.length.toString());

  salesActions.forEach((action, index) => {
                                     formData.append ( `salesActions.${index}.name`                 , action.name                          );
                                     formData.append ( `salesActions.${index}.active`               , action.active.toString()             );
                                     formData.append ( `salesActions.${index}.mediaId`              , action.mediaId.toString()            );
                                     formData.append ( `salesActions.${index}.productId`            , action.productId.toString()          );
                                     formData.append ( `salesActions.${index}.productVariant`       , action.productVariant.toString()     );
                                     formData.append ( `salesActions.${index}.productImage`         , action.productImage.toString()       );
                                     formData.append ( `salesActions.${index}.timecode`             , action.timecode                      );
                                     formData.append ( `salesActions.${index}.duration`             , action.duration                      );
                                     formData.append ( `salesActions.${index}.adPosition`           , action.adPosition                    );
                                     formData.append ( `salesActions.${index}.adWidth`              , action.adWidth.toString()            );
                                     formData.append ( `salesActions.${index}.onlyQRcode`           , action.onlyQRcode.toString()         );
                                     formData.append ( `salesActions.${index}.comment1`             , action.comment1                      );
                                     formData.append ( `salesActions.${index}.comment2`             , action.comment2                      );
                                     formData.append ( `salesActions.${index}.shapeColor1`          , action.shapeColor1                   );
                                     formData.append ( `salesActions.${index}.shapeColor2`          , action.shapeColor2                   );
                                     formData.append ( `salesActions.${index}.backgroundColor1`     , action.backgroundColor1              );
                                     formData.append ( `salesActions.${index}.backgroundColor2`     , action.backgroundColor2              );
                                     formData.append ( `salesActions.${index}.withImage`            , action.withImage.toString()          );
    if (action.alternateImageId    ) formData.append ( `salesActions.${index}.alternateImageId`     , action.alternateImageId.toString()   );
    if (action.alternateImageUrl   ) formData.append ( `salesActions.${index}.alternateImageUrl`    , action.alternateImageUrl             );
    if (action.alternateImageFile  ) formData.append ( `salesActions.${index}.alternateImageFile`   , action.alternateImageFile            );
    if (action.redirectionId       ) formData.append ( `salesActions.${index}.redirectionId`        , action.redirectionId.toString()      );
    if (action.redirectionUuid     ) formData.append ( `salesActions.${index}.redirectionUuid`      , action.redirectionUuid               );
    if (action.redirectionTargetUrl) formData.append ( `salesActions.${index}.redirectionTargetUrl` , action.redirectionTargetUrl          );
    if (action.redirectionImageId  ) formData.append ( `salesActions.${index}.redirectionImageId`   , action.redirectionImageId.toString() );
    if (action.redirectionImageUrl ) formData.append ( `salesActions.${index}.redirectionImageUrl`  , action.redirectionImageUrl           );
    if (action.redirectionImageFile) formData.append ( `salesActions.${index}.redirectionImageFile` , action.redirectionImageFile          );
    if (action.resultImageFile     ) formData.append ( `salesActions.${index}.resultImageFile`      , action.resultImageFile               );
  });

  try {
    const response = await axios.post(url, formData, {
      headers: { 'Accept': 'application/ld+json', 'Content-Type': 'multipart/form-data' },

                                           onUploadProgress: (event) => {

		                                        if (event.total)
												 {
                                                  const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                                  if ( setProgress && typeof (setProgress) !== "undefined" )
												   {
                                                    setProgress(percentCompleted);
												   }
                                                 }
                                              }
    });


    if (response.status === 201) {
      return {
        code: 1,
        comment: 'Sales campaign created successfully',
              payload : {} as any
      };
    } else {
      return handleError<void>(response.status, 'Error creating the sales campaign');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error occurred');
  }
};


export const deleteSalesCampaign = async (id: number): Promise<BackendResponse> => {
  const url = `${API_URLS.deleteSalesCampaign}`.replace('{id}', `${id}`);

  try {
    const response = await axios.delete(url);

    if (response.status === 204) {
      return {
        code: 1,
        comment: 'Sales campaign successfully deleted.',
              payload : {} as any
      };
    } else {
      return handleError<void>(response.status, 'Error deleting the sales campaign');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error');
  }
};

export const updateSalesCampaign = async ( id              : number                              ,
                                           name            : string                              ,
                                           active          : boolean                             ,
                                           activeScheduled : boolean                             ,
                                           beginningDate   : Date | null                         ,
                                           endingDate      : Date | null                         ,
                                           salesActions    : SalesAction[]                       ,
                                           setProgress?    : ((progress: number) => void) | null ) => {
  const url = `${API_URLS.patchSalesCampaign}`;

  const formData = new FormData();

  // Ajout des champs principaux de la campagne
                     formData.append ('id'              , id.toString()              );
                     formData.append ('name'            , name                       );
                     formData.append ('active'          , active.toString()          );
                     formData.append ('activeScheduled' , activeScheduled.toString() );
  if (beginningDate) formData.append ('beginningDate'   , beginningDate.toISOString());
  if (endingDate)    formData.append ('endingDate'      , endingDate.toISOString()   );

  // Ajout des actions de vente associées à la campagne
  formData.append('salesActions.length', salesActions.length.toString());

  salesActions.forEach((action, index) => {
                                     formData.append ( `salesActions.${index}.id`                   , action.id.toString()                 );
                                     formData.append ( `salesActions.${index}.name`                 , action.name                          );
                                     formData.append ( `salesActions.${index}.active`               , action.active.toString()             );
                                     formData.append ( `salesActions.${index}.mediaId`              , action.mediaId.toString()            );
                                     formData.append ( `salesActions.${index}.productId`            , action.productId.toString()          );
                                     formData.append ( `salesActions.${index}.productVariant`       , action.productVariant.toString()     );
                                     formData.append ( `salesActions.${index}.productImage`         , action.productImage.toString()       );                                     formData.append ( `salesActions.${index}.timecode`             , action.timecode                      );
                                     formData.append ( `salesActions.${index}.duration`             , action.duration                      );
                                     formData.append ( `salesActions.${index}.adPosition`           , action.adPosition                    );
                                     formData.append ( `salesActions.${index}.adWidth`              , action.adWidth.toString()            );
                                     formData.append ( `salesActions.${index}.onlyQRcode`           , action.onlyQRcode.toString()         );
                                     formData.append ( `salesActions.${index}.comment1`             , action.comment1                      );
                                     formData.append ( `salesActions.${index}.comment2`             , action.comment2                      );
                                     formData.append ( `salesActions.${index}.shapeColor1`          , action.shapeColor1                   );
                                     formData.append ( `salesActions.${index}.shapeColor2`          , action.shapeColor2                   );
                                     formData.append ( `salesActions.${index}.backgroundColor1`     , action.backgroundColor1              );
                                     formData.append ( `salesActions.${index}.backgroundColor2`     , action.backgroundColor2              );
                                     formData.append ( `salesActions.${index}.withImage`            , action.withImage.toString()          );
    if (action.alternateImageId    ) formData.append ( `salesActions.${index}.alternateImageId`     , action.alternateImageId.toString()   );
    if (action.alternateImageUrl   ) formData.append ( `salesActions.${index}.alternateImageUrl`    , action.alternateImageUrl             );
    if (action.alternateImageFile  ) formData.append ( `salesActions.${index}.alternateImageFile`   , action.alternateImageFile            );
    if (action.redirectionId       ) formData.append ( `salesActions.${index}.redirectionId`        , action.redirectionId.toString()      );
    if (action.redirectionUuid     ) formData.append ( `salesActions.${index}.redirectionUuid`      , action.redirectionUuid               );
    if (action.redirectionTargetUrl) formData.append ( `salesActions.${index}.redirectionTargetUrl` , action.redirectionTargetUrl          );
    if (action.redirectionImageId  ) formData.append ( `salesActions.${index}.redirectionImageId`   , action.redirectionImageId.toString() );
    if (action.redirectionImageUrl ) formData.append ( `salesActions.${index}.redirectionImageUrl`  , action.redirectionImageUrl           );
    if (action.redirectionImageFile) formData.append ( `salesActions.${index}.redirectionImageFile` , action.redirectionImageFile          );
    if (action.resultImageFile     ) formData.append ( `salesActions.${index}.resultImageFile`      , action.resultImageFile               );
 });
 
  try
   {
    const response = await axios.post(url, formData, {
      headers: { 'Accept': 'application/ld+json', 'Content-Type': 'multipart/form-data' },

                                           onUploadProgress: (event) => {

		                                        if (event.total)
												 {
                                                  const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                                  if ( setProgress && typeof (setProgress) !== "undefined" )
												   {
                                                    setProgress(percentCompleted);
												   }
                                                 }
                                              }
    });

  
    if (response.status === 200) {
      return {
        code: 1,
        comment: 'Sales campaign updated successfully',
              payload : {} as any
      };
    } else {
      return handleError<void>(response.status, 'Error updating the sales campaign');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<void>(-102, 'Unknown error occurred');
  }
};


export const getSalesCampaign = async (id: number): Promise<SalesCampaign | BackendResponse> => {
  const url = `${API_URLS.getSalesCampaign}`.replace('{id}', `${id}`);

  try {
    const response = await axios.get(url);


    if (response.status === 200) {
      return response.data; // Retourne les données de la campagne
    } else {
      return handleError<SalesCampaign | BackendResponse>(response.status, 'Error retrieving the sales campaign');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<SalesCampaign | BackendResponse>(-101, error.response?.data?.detail ?? error.message);
    }
    return handleError<SalesCampaign | BackendResponse>(-102, 'Unknown error occurred');
  }
};


// Fonction pour récupérer les actions de vente associées à une vidéo
export const getSalesActions = async (mediaId: number): Promise<BackendResponse_SalesAction> => {
  const url = `${API_URLS.getSalesActions}?mediaId=${mediaId}`;


  try {
    const response = await axios.get(url);

    console.log (url, response)


    if (response.status === 200) {
      const salesActions: SalesAction[] = response.data.map((action: any) => {
        const defaultAction = initializedSalesAction();
        return {
          ...defaultAction,
            id                   : action.id                   ?? defaultAction.id,
            creationDate         : parseDate(action.creationDate),
            name                 : action.name                 ?? defaultAction.name                 ,
            active               : action.active               ?? defaultAction.active               ,
			mediaId              : action.mediaId              ?? defaultAction.mediaId              ,
            productId            : action.productId            ?? defaultAction.productId            ,
            productVariant       : action.productVariant       ?? defaultAction.productVariant       ,
            productImage         : action.productImage         ?? defaultAction.productImage         ,
            timecode             : action.timecode             ?? defaultAction.timecode             ,
            duration             : action.duration             ?? defaultAction.duration             ,
            adPosition           : action.adPosition           ?? defaultAction.adPosition           ,
            adWidth              : action.adWidth              ?? defaultAction.adWidth              ,
            onlyQRcode           : action.onlyQRcode           ?? defaultAction.onlyQRcode           ,
            comment1             : action.comment1             ?? defaultAction.comment1             ,
            comment2             : action.comment2             ?? defaultAction.comment2             ,
            shapeColor1          : action.shapeColor1          ?? defaultAction.shapeColor1          ,
            shapeColor2          : action.shapeColor2          ?? defaultAction.shapeColor2          ,
            backgroundColor1     : action.backgroundColor1     ?? defaultAction.backgroundColor1     ,
            backgroundColor2     : action.backgroundColor2     ?? defaultAction.backgroundColor2     ,
            withImage            : action.withImage            ?? defaultAction.withImage            ,
            alternateImageId     : action.alternateImageId     ?? defaultAction.alternateImageId     ,
            alternateImageUrl    : action.alternateImageUrl    ?? defaultAction.alternateImageUrl    ,
            alternateImageFile   : action.alternateImageFile   ?? defaultAction.alternateImageFile   ,
            redirectionId        : action.redirectionId        ?? defaultAction.redirectionId        ,
            redirectionUuid      : action.redirectionUuid      ?? defaultAction.redirectionUuid      ,
			redirectionTargetUrl : action.redirectionTargetUrl ?? defaultAction.redirectionTargetUrl ,
            redirectionImageId   : action.redirectionImageId   ?? defaultAction.redirectionImageId   ,
			redirectionImageUrl  : action.redirectionImageUrl  ?? defaultAction.redirectionImageUrl  ,
			redirectionImageFile : action.redirectionImageFile ?? defaultAction.redirectionImageFile ,
            resultImageFile      : action.resultImageFile      ?? defaultAction.resultImageFile      ,
        };
      });
	  


      return {
        code: 1,
        comment: 'The retrieval of sales actions is complete.',
        payload: salesActions,
      };
    } else {
      return handleError<SalesAction[]>(response.status, 'Non-200 response from API');
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      return handleError<SalesAction[]>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<SalesAction[]>(-102, 'Unknown error');
  }
};


export const updateSalesCampaignVisibility = async ( id         : number  ,
                                                     visibility : boolean ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.updateSalesCampaignVisibility}`;
  const url = baseUrl.replace('{id}', `${id}`);
  const visibilityStr = visibility ? 'true' : 'false';

  const headers = {
    'Accept': 'application/ld+json',
    'Content-Type': 'application/merge-patch+json'
  };

  try 
   {
    const response = await axios.patch(url, { visibility: visibilityStr }, { headers });

    if (response.status === 200 || response.status === 204) 
	      {
           return {
                    code    : 1,
                    comment : 'La visibilité de la campagne de vente a été mise à jour.',
                    payload : {} as any
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Réponse inattendue de l\'API');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<void>(-102, 'Erreur inconnue');
  }
};

export const transcodeSalesCampaign = async ( id : number ): Promise<BackendResponse> => {

  const baseUrl = `${API_URLS.transcodeSalesCampaign}`;
  const url = baseUrl.replace('{id}', `${id}`);


  try 
   {
	   
    const response = await axios.get ( url );


    if (response.status === 200) 
	      {
           return {
                    code    : 1,
                    comment : 'Le transcodage de la campagne est lancé',
                    payload : {} as any
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Réponse inattendue de l\'API');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<void>(-102, 'Erreur inconnue');
  }
};

/*
export const getSalesCampaignArchive = async (id: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.getSalesCampaignArchive}`;
  const url = baseUrl.replace('{id}', `${id}`);

  try {
    const response = await axios.get(url, {
      responseType: 'blob',
    });


    if (response.status === 200) {
      const blob = new Blob([response.data], { type: 'application/zip' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;

      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'archive.zip';

      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
        if (fileNameMatch?.[1]) {
          fileName = fileNameMatch[1];
        }
      }

      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return {
        code: 1,
        comment: 'Le fichier a été téléchargé avec succès.',
        payload: null,
      };
    } else {
      return handleError<void>(response.status, 'Réponse non-200 de l’API');
    }
  } catch (error) {

    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Erreur inconnue');
  }
};
*/

export const getSalesCampaignArchive = async (id: number): Promise<BackendResponse> => {
  const baseUrl = `${API_URLS.getSalesCampaignArchive}`;
  const url = baseUrl.replace('{id}', `${id}`);

  try {
    const response = await axios.get(url, {
      responseType: 'blob',
    });

    if (response.status === 200) {
      const contentType = response.headers['content-type'] || '';
      const contentDisposition = response.headers['content-disposition'] || '';

      // 🔍 Extraction du nom du fichier depuis le header Content-Disposition
      let fileName = 'fichier_inconnu';
      const match = contentDisposition.match(/filename="?(.+?)"?$/);
      if (match?.[1]) {
        fileName = match[1];
      } else if (contentType.includes('zip')) {
        fileName = 'archive.zip';
      } else if (contentType.includes('mp4')) {
        fileName = 'video.mp4';
      }

      // 📦 Création du blob
      const blob = new Blob([response.data], { type: contentType });
      const downloadUrl = window.URL.createObjectURL(blob);

      // 💾 Téléchargement du fichier (ZIP ou MP4)
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      return {
        code: 1,
        comment: `Le fichier (${fileName}) a été téléchargé avec succès.`,
        payload: null,
      };
    } else {
      return handleError<void>(response.status, 'Réponse non-200 de l’API');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
    }

    return handleError<void>(-102, 'Erreur inconnue');
  }
};

/*
export const createSalesActionVideo = async ( name              : string                              ,
                                              timecode          : string                              ,
                                              duration          : string                              ,
											  adPosition        : string                              ,
											  resultImageFile   : File | null                         ,
                                              videoFileToUpload : File | null                         ,
                                              setProgress?      : ((progress: number) => void) | null ) => {
	
  const url = `${API_URLS.createSalesActionVideo}`;


  const formData = new FormData();

                         formData.append ( 'name'            , name            );
                         formData.append ( 'timecode'        , timecode        );
                         formData.append ( 'duration'        , duration        );
                         formData.append ( 'adPosition'      , adPosition      );
  if ( resultImageFile ) formData.append ( 'resultImageFile' , resultImageFile );


  try 
   {
    const response = await axios.post ( url , formData, { headers: { 'Accept': 'application/ld+json', 
														             'Content-Type': 'multipart/form-data' } } );

    if (response.status === 201) 
	      {
		  console.log (response)	  
			  
           const videoId = response.data.id

           if (videoFileToUpload) 
		    {
             const uploadConfig = {
                                    uploadChunkUrl    : API_URLS.uploadVideoChunk    ,
                                    finalizeUploadUrl : API_URLS.finalizeVideoUpload ,
                                    chunkSize         : 10 * 1024 * 1024             , // 10MB
                                    maxRetries        : 3                            ,
                                    enableResume      : true                         ,
                                    entityId          : videoId                      ,
                                    entityType        : 'video'                      ,
                                    autoStart         : true                         ,
                                    metadata          : {
                                                          videoId   : videoId ,
                                                          mediaType : 'video'
                                                        }
                                  };

             // Créer l'upload en arrière-plan avec le nouveau système
             const uploader = createUpload(videoFileToUpload, uploadConfig);

             console.log(`Upload vidéo démarré en arrière-plan pour la vidéo ID: ${videoId}, Upload ID: ${uploader.id}`);

             // Optionnel: connecter le callback de progression si fourni
             if (setProgress) 
			  {
               // Note: Le setProgress sera géré par le store Redux maintenant
               // mais on peut toujours l'utiliser pour des notifications locales
              }
            }

		  
           return {
                    code    : 1,
                    comment : 'Sales action video created successfully. Upload started in background.',
                    payload : videoId
                  };
          } 
	 else {
           return handleError<void>(response.status, 'Error creating the sales action video');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<void>(-102, 'Unknown error occurred');
   }
};
*/


             
export const createSalesCampaign2 = async ( name              : string                              ,
                                            salesActions      : SalesAction[]                       ,
                                            videoFileToUpload : File | null                         ,
                                            setProgress?      : ((progress: number) => void) | null ) => {

  console.log ("createSalesCampaign2", salesActions)

  const url = `${API_URLS.createSalesCampaignVideo}`;

  const formData = new FormData();

  // Ajout des champs principaux de la campagne
  formData.append('name', name);

  // Ajout des actions de vente associées à la campagne
  formData.append('salesActions.length', salesActions.length.toString());

  salesActions.forEach((action, index) => {
                                     formData.append ( `salesActions.${index}.id`                   , action.id.toString()                 );
                                     formData.append ( `salesActions.${index}.name`                 , action.name                          );
                                     formData.append ( `salesActions.${index}.active`               , action.active.toString()             );
                                     formData.append ( `salesActions.${index}.mediaId`              , action.mediaId.toString()            );
                                     formData.append ( `salesActions.${index}.productId`            , action.productId.toString()          );
                                     formData.append ( `salesActions.${index}.timecode`             , action.timecode                      );
                                     formData.append ( `salesActions.${index}.duration`             , action.duration                      );
                                     formData.append ( `salesActions.${index}.adPosition`           , action.adPosition                    );
                                     formData.append ( `salesActions.${index}.adWidth`              , action.adWidth.toString()            );
                                     formData.append ( `salesActions.${index}.onlyQRcode`           , action.onlyQRcode.toString()         );
                                     formData.append ( `salesActions.${index}.comment1`             , action.comment1                      );
                                     formData.append ( `salesActions.${index}.comment2`             , action.comment2                      );
                                     formData.append ( `salesActions.${index}.shapeColor1`          , action.shapeColor1                   );
                                     formData.append ( `salesActions.${index}.shapeColor2`          , action.shapeColor2                   );
                                     formData.append ( `salesActions.${index}.backgroundColor1`     , action.backgroundColor1              );
                                     formData.append ( `salesActions.${index}.backgroundColor2`     , action.backgroundColor2              );
                                     formData.append ( `salesActions.${index}.withImage`            , action.withImage.toString()          );
    if (action.alternateImageId    ) formData.append ( `salesActions.${index}.alternateImageId`     , action.alternateImageId.toString()   );
    if (action.alternateImageUrl   ) formData.append ( `salesActions.${index}.alternateImageUrl`    , action.alternateImageUrl             );
    if (action.alternateImageFile  ) formData.append ( `salesActions.${index}.alternateImageFile`   , action.alternateImageFile            );
    if (action.redirectionId       ) formData.append ( `salesActions.${index}.redirectionId`        , action.redirectionId.toString()      );
    if (action.redirectionUuid     ) formData.append ( `salesActions.${index}.redirectionUuid`      , action.redirectionUuid               );
    if (action.redirectionTargetUrl) formData.append ( `salesActions.${index}.redirectionTargetUrl` , action.redirectionTargetUrl          );
    if (action.redirectionImageId  ) formData.append ( `salesActions.${index}.redirectionImageId`   , action.redirectionImageId.toString() );
    if (action.redirectionImageUrl ) formData.append ( `salesActions.${index}.redirectionImageUrl`  , action.redirectionImageUrl           );
    if (action.redirectionImageFile) formData.append ( `salesActions.${index}.redirectionImageFile` , action.redirectionImageFile          );
    if (action.resultImageFile     ) formData.append ( `salesActions.${index}.resultImageFile`      , action.resultImageFile               );
  });

  try 
   {
    const response = await axios.post ( url , formData , {
                                                           headers          : { 
														                        'Accept': 'application/ld+json', 
																	            'Content-Type': 'multipart/form-data' 
																	          },

                                                           onUploadProgress : (event) => {

		                                                        if (event.total)
												                 {
                                                                  const percentCompleted = Math.round((event.loaded * 100) / event.total);

                                                                  if ( setProgress && typeof (setProgress) !== "undefined" )
												                   {
                                                                    setProgress(percentCompleted);
												                   }
                                                                 }
                                                            }
                                                         });

    if (response.status === 201) 
	      {
		   console.log (response)	  
			  
           const videoId = response.data.id

           if (videoFileToUpload) 
		    {
             const uploadConfig = {
                                    uploadChunkUrl    : API_URLS.uploadVideoChunk, // API_URLS.uploadMediaChunk     ,
                                    finalizeUploadUrl : API_URLS.finalizeVideoUpload2 ,
                                    chunkSize         : 10 * 1024 * 1024              , // 10MB
                                    maxRetries        : 3                             ,
                                    enableResume      : true                          ,
                                    entityId          : videoId                       ,
                                    entityType        : 'video'                       ,
                                    autoStart         : true                          ,
                                    metadata          : {
                                                          videoId   : videoId ,
                                                          mediaType : 'video'
                                                        }
                                  };

             // Créer l'upload en arrière-plan avec le nouveau système
             const uploader = createUpload(videoFileToUpload, uploadConfig);

             console.log(`Upload vidéo démarré en arrière-plan pour la vidéo ID: ${videoId}, Upload ID: ${uploader.id}`);

             // Optionnel: connecter le callback de progression si fourni
             if (setProgress) 
			  {
               // Note: Le setProgress sera géré par le store Redux maintenant
               // mais on peut toujours l'utiliser pour des notifications locales
              }
            }

		  
           return {
                    code    : 1,
                    comment : 'Sales action video created successfully. Upload started in background.',
                    payload : videoId
                  };			  
          }  
	 else {
           return handleError<void>(response.status, 'Error creating the sales campaign');
          }
   } 
  catch (error) 
   {
    if (axios.isAxiosError(error)) 
	 {
      return handleError<void>(-101, error.response?.data?.detail ?? error.message);
     }
	 
    return handleError<void>(-102, 'Unknown error occurred');
   }
};

